import React, { useCallback, useEffect, useState, useMemo } from "react";
import {
  Link,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import DataTable from "react-data-table-component";
import swal from "sweetalert";
import moment from "moment";
import { Modal } from "react-bootstrap";
import * as XLSX from "xlsx"; // Import for Excel download
import {
  jobListAPI,
  deleteJob,
  jobCompanyList,
  verifyThisJob,
  creatorList,
} from "../../api/job";
import { getAllCities, getAllSkills } from "../../api/common";
import useAccess from "../../api/useAccess";
import { job_type_list, job_types } from "../../common/job_types";
import { getReasonList } from "../../api/candidate";
import { getJobColumn, setJobColumn } from "../../../services/JobsService";
import { useSelector } from "react-redux";
import MultiSelect from "../App/Jobs/MultiSelect";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const useQuery = () => new URLSearchParams(useLocation().search);

const JobList = (props) => {
  const optionCount = 60;
  const { fetchAccess } = useAccess();
  const permission = fetchAccess();
  const navigate = useNavigate();
  //const location = useLocation();
  const query = useQuery();
  const paramValue = query.get("type");
  const download_access = useSelector(
    (state) => state?.auth?.auth?.download_access
  );

  const roleName = useSelector((state) => state.auth?.auth?.user_type);
  const roleID = useSelector((state) => state.auth?.auth?.roleid);

  const [searchParams, setSearchParams] = useSearchParams();
  const job_sector_param = searchParams.get("job_sector");
  const created_by_name = searchParams.get("created_by_name");
  const identity_type = searchParams.get("identity_type");

  const allClm = useMemo(
    () => [
      {
        clm: "id",
        spec: {
          name: "ID",
          minWidth: "100px",
          maxWidth: "100px",
          selector: (row) => row.id,
          sortable: true,
          wrap: true,
          sortField: "id",
        },
      },
      {
        clm: "verified_status",
        spec: {
          name: "Verification",
          selector: (row) =>
            row.verified_status ? (
              <button className="btn btn-success btn-sm">Verified</button>
            ) : (
              <button
                className="btn btn-primary btn-sm"
                onClick={() => verifyThisUser(row.id)}
              >
                Verify
              </button>
            ),
          minWidth: "110px",
          maxWidth: "110px",
          sortable: true,
          wrap: false,
          sortField: "verified_status",
        },
      },
      {
        clm: "profile_image",
        spec: {
          name: "Image",
          selector: (row) => (row.profile_image ? "Yes" : "No"),
          minWidth: "150px",
          maxWidth: "150px",
          sortable: true,
          wrap: true,
          sortField: "profile_image",
        },
      },
      {
        clm: "company_name",
        spec: {
          name: "Company Name",
          selector: (row) => row.company_name,
          minWidth: "200px",
          maxWidth: "200px",
          sortable: true,
          wrap: true,
          sortField: "company_name",
        },
      },
      {
        clm: "job_title",
        spec: {
          name: "Job Title",
          selector: (row) => row.job_title,
          minWidth: "200px",
          maxWidth: "200px",
          sortable: true,
          wrap: true,
          sortField: "job_title",
        },
      },
      {
        clm: "job_types",
        spec: {
          name: "Job Types",
          selector: (row) => job_type_list[row.job_types],
          minWidth: "200px",
          maxWidth: "200px",
          sortable: true,
          wrap: true,
          sortField: "job_types",
        },
      },
      {
        clm: "locations",
        spec: {
          name: "Location",
          selector: (row) => row.locations,
          minWidth: "200px",
          maxWidth: "200px",
          sortable: true,
          wrap: true,
          sortField: "locations",
        },
      },
      {
        clm: "job_sector",
        spec: {
          name: "Job Sector",
          selector: (row) => (row.job_sector === 1 ? "Tech" : "Non-tech"),
          minWidth: "150px",
          maxWidth: "150px",
          sortable: true,
          wrap: true,
          sortField: "job_sector",
        },
      },
      {
        clm: "identity",
        spec: {
          name: "Talent Pool",
          selector: (row) => row.identity_labels,
          minWidth: "150px",
          maxWidth: "150px",
          sortable: true,
          wrap: true,
          sortField: "identity",
        },
      },
      {
        clm: "min_experience",
        spec: {
          name: "Min experience",
          selector: (row) => row.min_experience + " Year/s",
          minWidth: "150px",
          maxWidth: "150px",
          sortable: true,
          wrap: true,
          sortField: "min_experience",
        },
      },
      {
        clm: "max_experience",
        spec: {
          name: "Max experience",
          selector: (row) => row.max_experience + " Year/s",
          minWidth: "150px",
          maxWidth: "150px",
          sortable: true,
          wrap: true,
          sortField: "max_experience",
        },
      },
      {
        clm: "job_position",
        spec: {
          name: "Job Position",
          selector: (row) => row.job_position,
          minWidth: "150px",
          maxWidth: "150px",
          sortable: true,
          wrap: true,
          sortField: "job_position",
        },
      },
      {
        clm: "job_ctc",
        spec: {
          name: "Job CTC",
          selector: (row) => row.job_ctc,
          minWidth: "150px",
          maxWidth: "150px",
          sortable: true,
          wrap: true,
          sortField: "job_ctc",
        },
      },
      {
        clm: "created_at",
        spec: {
          name: "Created Time",
          selector: (row) => row.created_at,
          minWidth: "200px",
          maxWidth: "200px",
          sortable: true,
          wrap: true,
          sortField: "created_at",
        },
      },
      {
        clm: "created_by_name",
        spec: {
          name: "Created By",
          selector: (row) => row.created_by_name,
          minWidth: "150px",
          maxWidth: "150px",
          sortable: true,
          wrap: true,
          sortField: "created_by_name",
        },
      },
      {
        clm: "updated_at",
        spec: {
          name: "Updated Time",
          selector: (row) => row.updated_at,
          sortable: true,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortField: "updated_at",
        },
      },
      {
        clm: "job_publish_schedule",
        spec: {
          name: "Job Publishing schedule",
          selector: (row) => row.job_publish_schedule,
          minWidth: "200px",
          maxWidth: "200px",
          wrap: true,
          sortable: true,
          sortField: "job_publish_schedule",
        },
      },
      {
        clm: "application_deadline",
        spec: {
          name: "Deadline",
          selector: (row) => row.application_deadline,
          sortable: true,
          minWidth: "150px",
          maxWidth: "150px",
          wrap: true,
          sortField: "application_deadline",
        },
      },
      {
        clm: "published",
        spec: {
          name: "Active status",
          selector: (row) =>
            row.published == 1 ? (
              <span className="badge badge-lg light badge-success">Active</span>
            ) : (
              <span className="badge badge-lg light badge-danger">
                InActive
              </span>
            ),
          sortable: true,
          minWidth: "130px",
          maxWidth: "130px",
          wrap: false,
          sortField: "published",
        },
      },
      {
        clm: "add_to_hot_jobs",
        spec: {
          name: "Add to Hot Jobs",
          selector: (row) => (row.add_to_hot_jobs == "1" ? "Yes" : "No"),
          sortable: true,
          minWidth: "150px",
          maxWidth: "150px",
          wrap: true,
          sortField: "add_to_hot_jobs",
        },
      },
      {
        clm: "show_popup_how_did_you_know",
        spec: {
          name: "Show Popup",
          selector: (row) =>
            row.show_popup_how_did_you_know == "1" ? "Yes" : "No",
          sortable: true,
          minWidth: "150px",
          maxWidth: "150px",
          wrap: true,
          sortField: "show_popup_how_did_you_know",
        },
      },
    ],
    [job_type_list]
  );

  const tableClm = useMemo(
    () => [
      {
        name: "Actions",
        button: "true",
        maxWidth: "250px",
        minWidth: "250px",
        wrap: false,
        cell: (row) => {
          return (
            <>
              {permission?.v === true ? (
                <>
                  <Link
                    to="#"
                    onClick={(e) => handleApplicantsClick(e, row.id)}
                  >
                    <button className="btn btn-secondary btn-sm light me-2">
                      <i className="fa fa-users"></i>
                    </button>
                  </Link>
                  <Link
                    target="_blank"
                    className="btn btn-secondary btn-sm me-2"
                    to={`${process.env.REACT_APP_FRONTEND}job-detail/${row.id}`}
                  >
                    <i className="fa fa-eye"></i>
                  </Link>
                  <Link
                    onClick={(event) => handleEditClick(event, row.id)}
                    className="btn btn-warning shadow btn-sm light me-2"
                    to="#"
                  >
                    <i className="fa fa-edit"></i>
                  </Link>
                  <Link
                    onClick={() => handleDeleteClick(row.id)}
                    className="btn btn-danger shadow btn-sm light me-2"
                    to="#"
                  >
                    <i className="fa fa-trash"></i>
                  </Link>
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      },
      // {
      //   name: "Candidates Applied",
      //   selector: (row) => "",
      //   minWidth: "110px",
      //   maxWidth: "110px",
      //   sortable: false,
      //   wrap: true,
      //   sortField: "",
      // },
      // {
      //   name: "Applicants Unlocked",
      //   selector: (row) => "",
      //   minWidth: "110px",
      //   maxWidth: "110px",
      //   sortable: false,
      //   wrap: true,
      //   sortField: "",
      // },
      // {
      //   name: "Applicants Downloaded",
      //   selector: (row) => "",
      //   minWidth: "110px",
      //   maxWidth: "110px",
      //   sortable: false,
      //   wrap: true,
      //   sortField: "",
      // },
    ],
    [permission]
  );

  //const rowsPerPage = rowsPerPage;
  const recruiter_id =
    paramValue === "recruiter" ? localStorage.getItem("recruiter_id") : "";
  const subrecruiter_id =
    paramValue === "subrecruiter"
      ? localStorage.getItem("subrecruiter_id")
      : "";

  const [companies, setCompanies] = useState([]);

  /* Rm update state start */
  const [data, setData] = useState([]);
  const [reason, setReason] = useState([]);
  const [skillList, setSkillList] = useState([]);
  const [identityList, setIdentityList] = useState([]);
  //const [citiesList, setCitiesList] = useState([]);
  const [columnModel, setColumnModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRow, setSelectedRows] = useState([]);
  const [selectedColumns, setSelectedColumn] = useState([]);
  const [columns, setColumn] = useState([]);
  const [allColumns] = useState(allClm);
  const [toggleCleared, setToggleCleared] = useState(false);
  const AdvanceSearchFields = useMemo(() => {
    return {
      location: "",
      min_experience: "",
      max_experience: "",
      registered_after: "",
      registered_before: "",
      published: "",
      hotjob: "",
      created_by_name: "",
    };
  });

  const SearchFields = useMemo(() => {
    return {
      company_id: "",
      skill_id: "",
      job_type: "",
      job_sector: job_sector_param ? job_sector_param : "",
      ...AdvanceSearchFields,
    };
  }, []);

  const [reqParams, setReqParams] = useState({
    ...SearchFields,
    page: currentPage,
    limit: perPage,
    sort_by: "created_at",
    sort_direction: "DESC",
    company_id: "",
    job_title: "",
    location: "",
    skill_id: "",
    job_type: "",
    job_sector: job_sector_param ? job_sector_param : "",
    recruiter_id: recruiter_id,
    subrecruiter_id: subrecruiter_id,
    identity: identity_type ? identity_type : "",
  });
  const [fetch, setFetch] = useState(false);
  const [addModel, setAddModal] = useState(false);

  const [advFields, setAdvFields] = useState(SearchFields);
  const [advanceParams, setAdvanceParams] = useState(SearchFields);
  const [clearAdvanceSearch, setClearAdvanceSearch] = useState(false);

  const [skills, setSkills] = useState([]);
  const [locations, setLocations] = useState([]);
  const [createdByList, setCreatorList] = useState([]);

  /* Rm update state end */

  const formatOptionList = useCallback((res, label, value, callback) => {
    if (res.length > 0) {
      let optionArray = [];
      res.forEach((obj, i) => {
        optionArray.push({ value: obj[value], label: obj[label] });
      });
      callback(optionArray);
    }
  }, []);

  const fetchFilterData = async () => {
    let s = await getAllSkills();
    formatOptionList(s, "skill_title", "id", setSkills);
    setSkillList(s);
    setCompanies(await jobCompanyList());
    let c = await getAllCities();
    formatOptionList(c, "city_name", "id", setLocations);
  };

  const fetchUsers = useCallback(
    (params) => {
      params = {
        ...params,
        registered_after:
          params.registered_after !== ""
            ? moment(params?.registered_after).format("yyyy-MM-DD")
            : "",
        registered_before:
          params.registered_before !== ""
            ? moment(params?.registered_before).format("yyyy-MM-DD")
            : "",
      };
      setToggleCleared(!toggleCleared);
      setLoading(true);
      jobListAPI(params)
        .then((res) => {
          setData(res?.data);
          setTotalRows(res?.total);
          setLoading(false);
          setFetch(false);
        })
        .catch((err) => {
          swal("Error", err?.message, "error");
          //console.log(err);
          setLoading(false);
          setFetch(false);
        });
    },
    [setFetch, toggleCleared]
  );

  const getActions = useCallback(
    (permission) => {
      return {
        name: "Actions",
        button: "true",
        maxWidth: "250px",
        minWidth: "250px",
        wrap: false,
        cell: (row) => {
          return (
            <>
              {permission?.v === true ? (
                <>
                  <Link
                    to="#"
                    onClick={(e) => handleApplicantsClick(e, row.id)}
                  >
                    <button className="btn btn-secondary btn-sm light me-2">
                      <i className="fa fa-users"></i>
                    </button>
                  </Link>
                  <Link
                    target="_blank"
                    className="btn btn-secondary btn-sm me-2"
                    to={`${process.env.REACT_APP_FRONTEND}job-detail/${row.id}`}
                  >
                    <i className="fa fa-eye"></i>
                  </Link>
                  <Link
                    onClick={(event) => handleEditClick(event, row.id)}
                    className="btn btn-warning shadow btn-sm light me-2"
                    to="#"
                  >
                    <i className="fa fa-edit"></i>
                  </Link>
                  <Link
                    onClick={() => handleDeleteClick(row.id)}
                    className="btn btn-danger shadow btn-sm light me-2"
                    to="#"
                  >
                    <i className="fa fa-trash"></i>
                  </Link>
                </>
              ) : (
                <></>
              )}
            </>
          );
        },
      };
    },
    [permission]
  );

  const handleFetchColumns = useCallback(
    (permission) => {
      getJobColumn("admin")
        .then((resp) => {
          if (
            resp.data?.job_search_keys !== undefined &&
            resp.data?.job_search_keys !== ""
          ) {
            let keys = resp.data?.job_search_keys;
            let keyArray = keys ? keys.split(",") : [];
            setSelectedColumn(keyArray);

            let newTableColumn = [
              getActions(permission),
              {
                name: "Candidates Applied",
                selector: (row) => row.total_applicants,
                //  sortable: true,
                //  wrap: true,
                //  sortField: "total_applicants",
              },
              {
                name: "Applicants Unlocked",
                selector: (row) => row.unlocked_applicants,
                width: "160px",
                //  sortable: true,
                //  wrap: true,
                //  sortField: "unlocked_applicants",
              },
              {
                name: "Applicants Downloaded",
                selector: (row) => row.downloaded_applicants,
                width: "180px",
                //sortable: true,
                //wrap: true,
                //sortField: "downloaded_applicants",
              },
            ];
            allColumns.forEach((clm, i) => {
              if (keyArray.includes(clm?.clm)) {
                newTableColumn.push(clm?.spec);
              }
              return false;
            });
            setColumn(newTableColumn);
            setFetch(true);
          } else {
            setFetch(true);
          }
        })
        .catch((err) => console.log(err));
    },
    [setFetch, columns]
  );

  useEffect(() => {
    if (columns.length < 1 && permission?.v) {
      setColumn(tableClm);
      handleFetchColumns(permission);
    }
  }, [columns, permission]);

  useEffect(() => {
    if (fetch) {
      let reqData = {};
      if (clearAdvanceSearch) {
        reqData = { ...reqParams, ...advanceParams };
      } else {
        reqData = { ...advanceParams, ...reqParams };
      }
      fetchUsers(reqData);
    }
  }, [fetch, reqParams, advanceParams, clearAdvanceSearch]);

  useEffect(() => {
    if (created_by_name) {
      setAdvanceParams((pre) => {
        return {
          ...pre,
          created_by_name: created_by_name,
        };
      });
      setClearAdvanceSearch(true);
      setFetch(true);
    }
  }, []);

  const checkAll = useCallback((isChecked) => {
    let list = document.getElementsByClassName("tbl-columns");
    if (isChecked) {
      for (let i = 0; i < list.length; i++) {
        document.getElementsByClassName("tbl-columns")[i].checked = true;
      }
    } else {
      for (let i = 0; i < list.length; i++) {
        document.getElementsByClassName("tbl-columns")[i].checked = false;
      }
    }
  }, []);

  const handlePageChange = useCallback(
    (page) => {
      setCurrentPage(page);
      setReqParams({
        ...reqParams,
        page: page,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handlePerRowsChange = useCallback(
    async (newPerPage, page) => {
      setPerPage(newPerPage);
      setReqParams({
        ...reqParams,
        limit: newPerPage,
      });
      setFetch(true);
    },
    [setReqParams, reqParams, setFetch]
  );

  const handleSort = useCallback(
    (column, sortDirection) => {
      if (column?.sortField !== undefined) {
        setReqParams({
          ...reqParams,
          sort_by: column.sortField,
          sort_direction: sortDirection,
        });
        setFetch(true);
      }
    },
    [reqParams, setReqParams, setFetch]
  );

  const handleSelectColumn = useCallback(() => {
    const checks = document.getElementsByClassName("column-check-box");
    let selectedChecks = [];
    for (let i = 0; i < checks.length; i++) {
      if (document.getElementsByClassName("column-check-box")[i].checked) {
        selectedChecks.push(
          document.getElementsByClassName("column-check-box")[i].value
        );
      }
    }

    setSelectedColumn(selectedChecks);

    let newTableColumn = [getActions(permission)];
    allColumns.forEach((clm, i) => {
      if (selectedChecks.includes(clm?.clm)) {
        newTableColumn.push(clm?.spec);
      }
    });

    setColumn(newTableColumn);

    setJobColumn(selectedChecks, "admin")
      .then((resp) => {
        setFetch(true);
      })
      .catch((error) => swal("Opps", error.message, "error"));
    setColumnModal(false);
  }, [allColumns, columns, setColumn, setFetch, permission]);

  const fetchReason = useCallback(() => {
    getReasonList(3)
      .then((res) => {
        setReason(res);
      })
      .catch((err) => console.log(err));
  }, []);

  const fetchCreatorList = useCallback(() => {
    creatorList(3)
      .then((res) => {
        setCreatorList(res);
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    fetchReason();
    fetchFilterData();
    fetchCreatorList();
  }, []);

  const handleFilterChange = useCallback(
    (event) => {
      const { name, value } = event.target;
      setReqParams({ ...reqParams, [name]: value, page: 1 });
      setFetch(true);
    },
    [reqParams, setReqParams]
  );

  const reasonOptionList = useCallback((reason=[]) => {
   console.log(reason);
   
    var span = document.createElement("span");
    let list = "<option value=''>Select Reason</option>";
    if (reason) {
      for (let index = 0; index < reason.length; index++) {
        const res = reason[index];
        list +=
          `<option value="` +
          res.id +
          `" key="` +
          index +
          `">` +
          res.reason +
          `</option>`;
      }
    }
    span.innerHTML =
      `<select id="reason" class="form-control">` + list + `</select>`;
    return span;
  }, []);

  const handleDeleteClick = useCallback(
    async (contactId) => {
      let Rres;
      if(reason.length==0){
         Rres = await getReasonList(3);
      }
      const span = await reasonOptionList(reason.length>0 ? reason : Rres);
      var candidate;
      if (contactId) {
        candidate = [contactId];
      } else {
        const jobsIds = selectedRow.map((c, i) => {
          return c.id;
        });
        candidate = jobsIds;
      }
      if (candidate.length < 1) {
        swal("Opps", "Please select at least 1 job to delete.", "error");
        return false;
      }
      
      const willDelete = await swal({
        title: "Are you sure?",
        text: "Are you sure that you want to delete this record?",
        icon: "warning",
        dangerMode: true,
        buttons: true,
        content: span,
      });

      if (willDelete) {
        let postData = {
          reason_id: document.getElementById("reason").value,
          ids: candidate.join(","),
        };
        //await deleteUser(contactId);
        await deleteJob(postData);
        //setSelectAll(false);
        setSelectedRows([]);
        setFetch(true);
        swal("Deleted!", "Record has been deleted!", "success");
      }
    },
    [setSelectedRows, selectedRow,reason]
  );

  const handleEditClick = async (event, id) => {
    event.preventDefault();
    localStorage.setItem("nid", id);
    navigate("/edit_Job");
  };

  const handleViewClick = async (event, id) => {
    event.preventDefault();
    localStorage.setItem("vid", id);
    navigate("/view_job");
  };

  const handleApplicantsClick = (e, job_id) => {
    e.preventDefault();
    localStorage.setItem("job_id", job_id);
    localStorage.removeItem("event_id");
    if (roleName === "2") {
      navigate("/manage-candidate?jobid=" + job_id);
    } else {
      navigate("/c_lists?type=job");
    }
  };

  const verifyThisUser = useCallback(
    async (id) => {
      //setIsLoading(true);
      try {
        const updatedData = {
          verified_status: 1,
          id: id,
          recruiter_id: recruiter_id,
        };
        let res = await verifyThisJob(updatedData);
        if (res !== false) {
          if (res?.error && res.error !== "undefined") {
            console.log("error", res.error);
            swal("Error", res.error, "error");
          } else {
            //setPage(0);
            //dataFetch(true);
            setFetch(true);
            swal("Success", "Job updated successfully", "success");
          }
        } else {
          swal(
            "Error",
            "There was an error updating the job. Please contact administrator!",
            "error"
          );
        }
      } catch (error) {
        swal("Error", "There was an error updating the job", "error");
      } finally {
        //setIsLoading(false);
      }
    },
    [setFetch, verifyThisJob]
  );

  const handleVerifySelected = useCallback(
    async (verifiedStatus) => {
      if (selectedRow.length === 0) {
        swal("No jobs selected", "Please select jobs to update.", "info");
        return;
      }

      try {
        await Promise.all(
          selectedRow.map((job) =>
            verifyThisJob({ id: job.id, verified_status: verifiedStatus })
          )
        );
        swal(
          "Success",
          `Jobs have been ${verifiedStatus ? "verified" : "unverified"}.`,
          "success"
        );
        //dataFetch(true); // Refresh the list
        setFetch(true);
        setSelectedRows([]);
        //setSelectAll(false);
      } catch (error) {
        console.error("Error updating jobs:", error);
        swal("Error", "Could not update selected jobs.", "error");
      }
    },
    [setSelectedRows, selectedRow]
  );

  const handleCopy = () => {
    const text = data.map((job) => Object.values(job).join(", ")).join("\n");
    navigator.clipboard.writeText(text).then(() => {
      swal("Copied!", "Table data copied to clipboard.", "success");
    });
  };

  const handleDownloadExcel = () => {
    const displayedData = data.map((job) => ({
      Image: job.profile_image ? "Yes" : "No",
      "Job Code": job.id,
      "Company Name": job.company_name,
      "Job Title": job.job_title,
      Location: job.locations,
      "Job Sector": job.job_sector === 1 ? "Tech" : "Non-tech",
      "Min. Experince": job.min_experience,
      "Max. Experince": job.max_experience,
      "Job position": job.job_position,
      "Job CTC": job.job_ctc,
      "Created Time": job.created_at,
      "Created By": job?.created_by_name || "N/A", // Handle creator name
      "Updated Time": job.updated_at || "N/A", // Handle updated time
      "Job Publishing Schedule": job.job_publish_schedule || "N/A", // Publishing schedule
      Deadline: job.application_deadline || "N/A", // Application deadline
      "Active Status": job.published === 1 ? "Active" : "Inactive", // Published status
      "Add to Hot Jobs": job.add_to_hot_jobs === "1" ? "Yes" : "No", // Hot job status
      "Show Popup": job.show_popup_how_did_you_know === "1" ? "Yes" : "No", // Popup flag
    }));

    const worksheet = XLSX.utils.json_to_sheet(displayedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Jobs");
    XLSX.writeFile(workbook, "JobList.xlsx");
  };

  const getMultiSelectValue = useCallback((values) => {
    if (values && values?.length > 0) {
      let ids = [];
      values.forEach((element, i) => {
        ids.push(element?.value);
      });
      return ids.toString();
    }
    return "";
  }, []);

  const onSaveAdvanceSearch = useCallback(() => {
    setReqParams({
      ...reqParams,
      company_id: "",
      skill_id: "",
      job_type: "",
      job_sector: "",
      page: 1,
    });
    setAdvanceParams({
      ...advFields,
      registered_after:
        advFields.registered_after !== ""
          ? moment(advFields?.registered_after).format("yyyy-MM-DD")
          : "",
      registered_before:
        advFields.registered_before !== ""
          ? moment(advFields?.registered_before).format("yyyy-MM-DD")
          : "",
      skill_id: getMultiSelectValue(advFields?.skill_id),
      location: getMultiSelectValue(advFields?.location),
    });
    setClearAdvanceSearch(true);
    setAddModal(false);
    setFetch(true);
  }, [
    setReqParams,
    reqParams,
    setAdvanceParams,
    advFields,
    setFetch,
    setClearAdvanceSearch,
    setAddModal,
    getMultiSelectValue,
  ]);

  const onClearAdvanceSearch = useCallback(() => {
    setReqParams({ ...reqParams, page: 1 });
    setClearAdvanceSearch(false);
    setAdvFields(SearchFields);
    setAdvanceParams(SearchFields);
    setFetch(true);
  }, [
    setReqParams,
    reqParams,
    setClearAdvanceSearch,
    SearchFields,
    setAdvanceParams,
    setAdvFields,
    setFetch,
  ]);

  const selectOptions = useCallback(() => {
    let options = [];
    for (let index = 0; index <= optionCount; index++) {
      options.push(
        <option value={index} key={index}>
          {index}
        </option>
      );
    }
    return options;
  }, [optionCount]);

  const handleSearchMultiSelect = useCallback(
    (values, inputname) => {
      if (values?.length > 0) {
        setAdvFields({ ...advFields, [inputname]: values });
      } else {
        setAdvFields({ ...advFields, [inputname]: "" });
      }
    },
    [advFields, setAdvFields]
  );

  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap">
        <h4 className="fs-20 font-w600 me-auto">{""}</h4>
        {clearAdvanceSearch && (
          <button
            onClick={onClearAdvanceSearch}
            className="btn btn-danger me-3 btn-sm"
          >
            <i className="fas fa-times me-1"></i>Reset
          </button>
        )}
        <button
          onClick={() => setAddModal(true)}
          className="btn btn-info me-3 btn-sm"
        >
          <i className="fas fa-search me-1"></i>Search
        </button>
        {paramValue == null && permission.a && (
          <Link to="/new_Job" className="btn btn-primary btn-sm">
            <i className="fas fa-plus me-2"></i>Add New Job
          </Link>
        )}

        <button
          onClick={() => setColumnModal(true)}
          className="btn btn-secondary ms-3 btn-sm"
        >
          Select Column
        </button>

        <button
          className="btn btn-success btn-sm ms-3"
          onClick={() => handleVerifySelected(1)}
        >
          Verify Selected
        </button>
        <button
          className="btn btn-warning btn-sm ms-3"
          onClick={() => handleVerifySelected(0)}
        >
          Unverify Selected
        </button>
      </div>
      <div className="d-flex justify-content-end mb-4">
        <div className="d-flex gap-3">
          <select
            className="form-select"
            name="company_id"
            value={reqParams.company_id}
            onChange={handleFilterChange}
          >
            <option value="">Select Company</option>
            {companies &&
              companies?.length > 0 &&
              companies.map((company) => (
                <option key={company.id} value={company.id}>
                  {company.company_name}
                </option>
              ))}
          </select>

          <select
            className="form-select"
            name="skill_id"
            value={reqParams.skill_id}
            onChange={handleFilterChange}
          >
            <option value="">Filter by Skills</option>
            {skillList?.map((item) => {
              return (
                <option key={item.id} value={item.id}>
                  {item.skill_title}
                </option>
              );
            })}
          </select>
          <select
            className="form-select"
            name="job_type"
            value={reqParams.job_type}
            onChange={handleFilterChange}
          >
            <option value="">Select Job Type</option>
            {job_types.map((jobType, index) => (
              <option key={index} value={jobType.id}>
                {jobType.title}
              </option>
            ))}
          </select>
          <select
            className="form-select"
            name="job_sector"
            value={reqParams.job_sector}
            onChange={handleFilterChange}
          >
            <option value="">Select Job Sector</option>
            <option value="1">Tech</option>
            <option value="0">Non-tech</option>
          </select>
          <select
            className="form-select"
            name="identity"
            value={reqParams.identity}
            onChange={handleFilterChange}
          >
            <option value="">Select Talent Pool</option>
            <option value="1">LGBT+ Talent</option>
            <option value="3">Women Talent</option>
            {roleID == "1" && <option value="2">Man Talent</option>}
          </select>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="row mb-2">
            <div className="col-xl-10">
              <button
                className="btn btn-danger btn-sm me-3"
                onClick={() => handleDeleteClick("")}
              >
                <i className="fa fa-trash"></i> Delete
              </button>

              {download_access && (
                <>
                  <button
                    className="btn btn-secondary btn-sm me-3"
                    onClick={handleCopy}
                  >
                    COPY
                  </button>
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={handleDownloadExcel}
                  >
                    Download Excel
                  </button>
                </>
              )}
            </div>
            {/* <div className="col-xl-2">
              <select
                className="form-select w-100 me-3"
                value={rowsPerPage}
                onChange={handleRowsPerPageChange}
              >
                {[10, 25, 50, 100, 1000, 2000].map((size) => (
                  <option key={size} value={size}>
                    Show {size}
                  </option>
                ))}
              </select>
            </div> */}
          </div>
          <div className="table-responsive">
            {/* <table className="table display mb-4 dataTablesCard Plan-table table-responsive-xl card-table dataTable no-footer">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                  </th>
                  <th onClick={() => handleSort("verified_status")}>
                    Verification{renderSortIcon("verified_status")}
                  </th>
                  <th onClick={() => handleSort("id")}>
                    Job Code{renderSortIcon("id")}
                  </th>
                  <th onClick={() => handleSort("company_name")}>
                    Company Name {renderSortIcon("company_name")}
                  </th>
                  <th onClick={() => handleSort("job_title")}>
                    Job Title {renderSortIcon("job_title")}
                  </th>
                  <th>Location</th>
                  <th onClick={() => handleSort("job_sector")}>
                    Job Sector {renderSortIcon("job_sector")}
                  </th>

                  <th onClick={() => handleSort("created_at")}>
                    Created Time{renderSortIcon("created_at")}
                  </th>

                  <th onClick={() => handleSort("created_by_name")}>
                    Created By{renderSortIcon("created_by_name")}
                  </th>
                  <th onClick={() => handleSort("updated_at")}>
                    Updated Time{renderSortIcon("updated_at")}
                  </th>
                  <th onClick={() => handleSort("job_publish_schedule")}>
                    Job Publishing schedule
                    {renderSortIcon("job_publish_schedule")}
                  </th>
                  <th onClick={() => handleSort("application_deadline")}>
                    Deadline{renderSortIcon("application_deadline")}
                  </th>
                  <th onClick={() => handleSort("published")}>
                    Active status{renderSortIcon("published")}
                  </th>
                  <th onClick={() => handleSort("add_to_hot_jobs")}>
                    Add to Hot Jobs
                    {renderSortIcon("add_to_hot_jobs")}
                  </th>
                  <th onClick={() => handleSort("show_popup_how_did_you_know")}>
                    Show Popup
                    {renderSortIcon("show_popup_how_did_you_know")}
                  </th>

                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {data.length > 0 ? (
                  data.map((job, index) => (
                    <tr key={job.id}>
                      <td>
                        <input
                          type="checkbox"
                          checked={selectedJobs.includes(job.id)}
                          onChange={() => handleCheckboxChange(job.id)}
                        />
                      </td>
                      <td>{isVerifiedUserHTML(job)}</td>
                      <td>{job.id}</td>
                      <td>{job.company_name}</td>
                      <td>{job.job_title}</td>
                      <td>{job.locations}</td>
                      <td>{job.job_sector === 1 ? "Tech" : "Non-tech"}</td>
                      <td>{job.created_at}</td>
                      <td>{job?.created_by_name}</td>
                      <td>{job.updated_at}</td>
                      <td>{job.job_publish_schedule}</td>
                      <td>{job.application_deadline}</td>
                      <td>{job.published == 1 ? "Active" : "InActive"}</td>
                      <td>{job.add_to_hot_jobs == "1" ? "Yes" : "No"}</td>
                      <td>
                        {job.show_popup_how_did_you_know == "1" ? "Yes" : "No"}
                      </td>

                      {permission.v ? (
                        <td>
                          <div className="d-flex justify-content-end">
                            <div>
                              <Link
                                to={"#"}
                                className="btn btn-secondary light mr-2"
                                onClick={(e) =>
                                  handleApplicantsClick(e, job.id)
                                }
                              >
                                Applicants
                              </Link>
                            </div>
                            <div className="action-buttons d-flex justify-content-end">
                              <a
                                href={`${process.env.REACT_APP_FRONTEND}jobs/job-detail/${job.id}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-secondary shadow btn-xs sharp me-1"
                              >
                                <i className="fas fa-eye"></i>
                              </a>

                              <Link
                                onClick={(event) =>
                                  handleEditClick(event, job.id)
                                }
                                className="btn btn-primary shadow btn-xs sharp me-1"
                              >
                                <i className="fas fa-pencil-alt"></i>
                              </Link>
                              <Link
                                onClick={() => handleDeleteClick(job.id)}
                                className="btn btn-danger shadow btn-xs sharp"
                              >
                                <i className="fas fa-trash-alt"></i>
                              </Link>
                            </div>
                          </div>
                        </td>
                      ) : null}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">
                      No Records Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table> */}

            <DataTable
              //className="table  display dataTablesCard job-table table-responsive-xl card-table dataTable no-footer"
              columns={columns}
              data={data}
              progressPending={loading}
              pagination
              paginationServer
              paginationTotalRows={totalRows}
              paginationDefaultPage={currentPage}
              onChangeRowsPerPage={handlePerRowsChange}
              onChangePage={handlePageChange}
              paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 200, 500]}
              selectableRows
              persistTableHead
              //   subHeader
              //   //conditionalRowStyles={conditionalRowStyles}
              //   subHeaderComponent={
              //     <SearchInputComponent setFilterText={handleSearchText} />
              //   }
              clearSelectedRows={toggleCleared}
              onSelectedRowsChange={({ selectedRows }) =>
                setSelectedRows(selectedRows)
              }
              onSort={handleSort}
              sortServer
              fixedHeader={true}
              fixedHeaderScrollHeight={"500px"}
            />
          </div>
        </div>
      </div>

      {/* {renderPagination()} */}

      <Modal
        className="modal fade"
        size="lg"
        show={columnModel}
        backdrop="static"
        onHide={setColumnModal}
      >
        <div role="document">
          <div className="">
            <div className="modal-header">
              <h4 className="modal-title fs-20">Select columns to be shown.</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setColumnModal(false)}
                data-dismiss="modal"
              >
                <span></span>
              </button>
            </div>
            <div className="modal-body">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
              <div className="add-contact-box">
                <div className="add-contact-content" id="setColumn">
                  <div className="row">
                    {allColumns.map((column, i) => {
                      return (
                        <div className="col-md-4 form-group" key={i}>
                          <input
                            id={column?.clm}
                            className="form-check-input tbl-columns column-check-box"
                            type="checkbox"
                            value={column?.clm}
                            defaultChecked={selectedColumns.includes(
                              column?.clm
                            )}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={column?.clm}
                          >
                            {column.spec.name}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                  <div className="row">
                    <div className="col-md-4 form-group">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="select-all"
                        onChange={(e) => {
                          checkAll(e.target.checked);
                        }}
                      />
                      <label className="form-check-label" htmlFor="select-all">
                        Select All
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="submit"
                className="btn btn-success"
                onClick={handleSelectColumn}
              >
                Save
              </button>
              <button
                type="button"
                onClick={() => setColumnModal(false)}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i> Close
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal
        className="modal fade"
        size="lg"
        show={addModel}
        backdrop="static"
        onHide={setAddModal}
      >
        <div role="document">
          <div className="modal-header">
            <h4 className="modal-title fs-20">Search</h4>
            <button
              type="button"
              className="btn-close"
              onClick={() => setAddModal(false)}
              data-dismiss="modal"
            >
              <span></span>
            </button>
          </div>
          <div className="modal-body p-1">
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">
                      Register after
                    </label>
                    <div className="mb-1 form-group">
                      <DatePicker
                        className={`form-control`}
                        wrapperClassName="d-inline"
                        dateFormat="Y-MM-dd"
                        maxDate={new Date()}
                        peekNextMonth
                        isClearable
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Select date"
                        //selected={reqParams?.registered_after}
                        onFocus={(e) => e.target.blur()}
                        selected={
                          advFields?.registered_after
                            ? advFields?.registered_after
                            : ""
                        }
                        onChange={(date) => {
                          setAdvFields({
                            ...advFields,
                            registered_after: date ? date : "",
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">
                      Register before
                    </label>
                    <div className=" mb-1 form-group">
                      <DatePicker
                        className={`form-control`}
                        wrapperClassName="d-inline"
                        dateFormat="Y-MM-dd"
                        maxDate={new Date()}
                        isClearable
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        placeholderText="Select date"
                        //selected={reqParams?.registered_after}
                        onFocus={(e) => e.target.blur()}
                        selected={
                          advFields?.registered_before
                            ? advFields?.registered_before
                            : ""
                        }
                        onChange={(date) => {
                          setAdvFields({
                            ...advFields,
                            registered_before: date ? date : "",
                          });
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">
                      Select Company
                    </label>
                    <div className="input-group mb-1 form-group">
                      <select
                        className="form-select"
                        name="company_id"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            company_id: e.target.value,
                          })
                        }
                        defaultValue={advFields?.company_id}
                      >
                        <option value="">Select Company</option>
                        {companies &&
                          companies?.length > 0 &&
                          companies.map((company) => (
                            <option key={company.id} value={company.id}>
                              {company.company_name}
                            </option>
                          ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="skills">Skills</label>
                    <div className="mb-3 form-group">
                      <MultiSelect
                        multiple={true}
                        options={skills}
                        onValueSelect={handleSearchMultiSelect}
                        selected={advFields?.skill_id}
                        name="skill_id"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="city">Location</label>
                    <div className="mb-3 form-group">
                      <MultiSelect
                        multiple={true}
                        options={locations}
                        onValueSelect={handleSearchMultiSelect}
                        selected={advFields?.location}
                        name="location"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">Job Type</label>
                    <div className="input-group mb-1 form-group">
                      <select
                        className="form-select"
                        name="job_type"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            job_type: e.target.value,
                          })
                        }
                        defaultValue={advFields?.job_type}
                      >
                        <option value="">Select Job Type</option>
                        {job_types.map((jobType, index) => (
                          <option key={index} value={jobType.id}>
                            {jobType.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">Job Sector</label>
                    <div className="input-group mb-1 form-group">
                      <select
                        className="form-select"
                        name="job_sector"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            job_sector: e.target.value,
                          })
                        }
                        defaultValue={advFields?.job_sector}
                      >
                        <option value="">Select Job Sector</option>
                        <option value="1">Tech</option>
                        <option value="0">Non-tech</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row mb-2">
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">
                      Experience min
                    </label>
                    <div className="input-group mb-1 form-group">
                      <select
                        id="experience_min"
                        className="form-select"
                        type="text"
                        name="experience_min"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            min_experience: e.target.value,
                          })
                        }
                        defaultValue={advFields?.min_experience}
                      >
                        <option value="">Please Select</option>
                        {selectOptions()}
                      </select>
                      <span className="input-group-text" id="basic-addon1">
                        Years
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label htmlFor="formGroupExampleInput">
                      Experience max
                    </label>
                    <div className="input-group mb-1 form-group">
                      <select
                        id="experience_max"
                        className="form-select"
                        type="text"
                        name="experience_max"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            max_experience: e.target.value,
                          })
                        }
                        defaultValue={advFields?.max_experience}
                      >
                        <option value="">Please Select</option>
                        {selectOptions()}
                      </select>
                      <span className="input-group-text" id="basic-addon1">
                        Years
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="candidate_status">Job Status</label>
                    <div className="input-group mb-3 form-group">
                      <select
                        id="published"
                        className="form-select"
                        type="text"
                        name="published"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            published: e.target.value,
                          })
                        }
                        defaultValue={advFields?.published}
                      >
                        <option value="">Please Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="candidate_status">Hot Job</label>
                    <div className="input-group mb-3 form-group">
                      <input
                        id="id"
                        class="form-check-input tbl-columns column-check-box"
                        type="checkbox"
                        value="id"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            hotjob: e.target.checked ? "1" : "",
                          })
                        }
                        defaultChecked={advFields?.hotjob}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="candidate_status">Created By</label>
                    <div className="input-group mb-3 form-group">
                      <select
                        id="published"
                        className="form-select"
                        type="text"
                        name="created_by_name"
                        onChange={(e) =>
                          setAdvFields({
                            ...advFields,
                            created_by_name: e.target.value,
                          })
                        }
                        defaultValue={advFields?.created_by_name}
                      >
                        <option value="">Please Select</option>
                        {createdByList.map((jobType, index) => (
                          <option key={index} value={jobType.created_by_name}>
                            {jobType.created_by_name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="submit"
              className="btn btn-success"
              onClick={onSaveAdvanceSearch}
            >
              Search
            </button>
            <button
              type="button"
              onClick={() => setAddModal(false)}
              className="btn btn-danger"
            >
              <i className="flaticon-delete-1"></i> Close
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default JobList;
